import React, {Fragment} from "react";
import StepQuestion from "components/Step/StepQuestion";
import StepButton from "components/Step/StepButton";
import StepDatePicker from "components/Step/StepDatePicker";
import StepFeedback from "components/Step/StepFeedback";
import * as ValidationRule from "utils/ValidationRule";
import ValidationMethods from "utils/ValidationMethods";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import IdTypeEnum from "domain/Customer/IdTypeEnum";
import StepInputLabel from "components/Step/StepInputLabel";
import StepInformation from "components/Step/StepInformation";

export default class DOBCaptureStep extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.verb = this.props.value && this.props.value.length > 0 ? "confirm" : "input";

        let validations = [{
            field: "dob",
            value: this.props.value,
            yupRule: ValidationRule.getDOBValidator("Date of Birth", true)
        }];

        let errors = ValidationMethods.validateInitial(this, validations);

        this.state = {
            errors: errors
        }
    }

    onChange(dt) {
        ValidationMethods.validateOnChange(this, "dob", dt);

        if (this.props.onChange) {
            this.props.onChange(dt);
        }
    }

    isInvalid(key) {
        return this.state.errors[key] !== undefined && this.state.errors[key].length > 0
    }

    render() {
        return <Fragment>
            {
                this.props[RegistrationElements.ID_TYPE] === IdTypeEnum.SA_ID
                    ? this.renderDOBPredefined()
                    : this.renderDOBPicker()
            }
            <StepButton
                onClick={this.props.onNextClick}
                disabled={this.state.errors.dob !== undefined}
            >
                {this.props.nextText || "Next"}
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {this.props.backText || "Back"}
            </StepButton>
        </Fragment>
    }

    renderDOBPicker() {
        return <Fragment>
            <StepQuestion>
                Please {this.verb} your date of birth:
            </StepQuestion>
            <StepInputLabel>
                Date of Birth
                <StepInformation>
                    You must be over the age of 18 to use this service.
                </StepInformation>
            </StepInputLabel>
            <StepDatePicker
                id={"dob"}
                type={"PAST"}
                placeholder={"eg. 1980-04-28"}
                value={this.props.value}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid("dob")}
            />
            <StepFeedback>
                {this.state.errors.dob}
            </StepFeedback>
        </Fragment>
    }

    renderDOBPredefined() {
        return <Fragment>
            <StepQuestion>
                Based on your ID Number, your Date of Birth has been determined as:
            </StepQuestion>
            <StepQuestion>
                {this.props.value}
            </StepQuestion>
        </Fragment>
    }
}